module.exports = __webpack_public_path__ + "img/Melani-Method-web-WHITE-logo-250pxH.b82522f2.png";